import { STATS } from "../constants/data";

export default function Stats() {
  return (
    <div
      style={{
        background: "white",
        borderBottom: "1px solid #f1f5f9",
        boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
      }}
    >
      <div
        style={{
          maxWidth: 900,
          margin: "0 auto",
          padding: "28px 20px",
          display: "grid",
          gridTemplateColumns: "repeat(4,1fr)",
          gap: 20,
          textAlign: "center",
        }}
      >
        {STATS.map((stat, i) => (
          <div key={i}>
            <div style={{ fontSize: 32, fontWeight: 800, color: "#1d4ed8" }}>
              {stat.value}
            </div>
            <div style={{ fontSize: 13, color: "#64748b", marginTop: 4 }}>
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
